// extracted by mini-css-extract-plugin
module.exports = {"wishlistButton":"wishlist_wishlistButton__RQump","wishlistButton__active":"wishlist_wishlistButton__active__RCY_W"};